import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Object from './components/Links';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

export default ({match, regions,roles}) => (

	<div>
		<Switch>
			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
